import { lazy, Suspense, useRef } from 'react';

// Duenner Einstieg: pdf.js (react-pdf + pdfjs-dist, mehrere hundert KB) liegt in
// PdfViewerCanvas und wird erst geladen, wenn wirklich ein PDF angezeigt wird.
// Vorher zog LayoutManager -> FilePreview -> PdfViewer pdf.js statisch ins
// Haupt-Bundle, d. h. jeder CUI-Start lud und parste es mit.
const PdfViewerCanvas = lazy(() => import('./PdfViewerCanvas'));

export function PdfViewer({ url }: { url: string }) {
  /* Startmarke VOR dem Nachladen des pdf.js-Chunks (Zweitpruefung R1 Panelzeit): sonst fehlte jedem frischen
   * Fenster die Chunk-Zeit in „Oeffnen -> erste Seite". */
  const start = useRef<{ url: string; t: number }>({ url: '', t: 0 });
  if (start.current.url !== url) start.current = { url, t: performance.now() };
  return (
    <Suspense fallback={<div style={{ color: 'var(--tn-text-muted)', padding: 24 }}>PDF wird geladen…</div>}>
      {/* key: je Datei frisch einhängen, sonst beobachtet der Seiten-Observer nach Dateiwechsel gleicher Seitenzahl die alten Knoten (Zweitprüfung R1) */}
      <PdfViewerCanvas key={url} url={url} geoeffnetUm={start.current.t} />
    </Suspense>
  );
}
